module.exports = __webpack_public_path__ + "static/img/10koło2D.44adcf1d.png";